"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreYouSureDialog = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Dialog_1 = require("../Dialog");
var DefaultMessage = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { children: "You will lose any unsaved changes." }), (0, jsx_runtime_1.jsx)("p", { children: "Click \u2018Continue\u2019 to proceed without saving." })] }));
/**
 * @deprecated in favor of ConfirmDialog
 * @todo merge with ConfirmDialog
 */
exports.AreYouSureDialog = react_1.default.memo(function (_a) {
    var _b = _a.confirmText, confirmText = _b === void 0 ? 'continue' : _b, _c = _a.cancelText, cancelText = _c === void 0 ? 'cancel' : _c, _d = _a.title, title = _d === void 0 ? 'Are you sure...' : _d, _e = _a.children, children = _e === void 0 ? DefaultMessage : _e, _f = _a.disablePrimaryCTA, disablePrimaryCTA = _f === void 0 ? false : _f, _g = _a.disableSecondaryCTA, disableSecondaryCTA = _g === void 0 ? false : _g, onConfirm = _a.onConfirm, onCancel = _a.onCancel, _h = _a.loading, loading = _h === void 0 ? false : _h, otherProps = __rest(_a, ["confirmText", "cancelText", "title", "children", "disablePrimaryCTA", "disableSecondaryCTA", "onConfirm", "onCancel", "loading"]);
    return ((0, jsx_runtime_1.jsx)(Dialog_1.Dialog, __assign({}, otherProps, { title: title, actions: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ onClick: onCancel, color: "primary", variant: "contained", "data-testid": "btn-dialog-cancel", disabled: disableSecondaryCTA || loading }, { children: cancelText })), (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ onClick: onConfirm, color: "primary", variant: "contained", "data-testid": "btn-dialog-confirm", disabled: disablePrimaryCTA || loading }, { children: loading ? ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ position: "relative" }, { children: (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ position: "absolute", left: "50%", top: "50%", style: { transform: 'translate(-50%, -50%)' } }, { children: loading && (0, jsx_runtime_1.jsx)(core_1.CircularProgress, { color: "inherit", size: "18px" }) })) }))) : (confirmText) }))] }) }, { children: children })));
});
